import z from "zod";
const UsageProductSchema = z.enum(["http", "webSockets", "webhooks"]);
const UsageActionUnit = z.enum(["USD", "CU"]);
const UsageActionMetric = z.enum(["SUPERNODE_CU", "BLAST_CU"]);
export {
  UsageActionMetric,
  UsageActionUnit,
  UsageProductSchema
};
//# sourceMappingURL=usage.js.map